import { AxiosResponse } from "axios";
import { api, CustomAxiosRequestConfig, ENDPOINTS } from "@app/api";
import {
  GroupDetailInspectionFormsRequestDef,
  GroupMachineLocationsRequest,
  GroupMachinesRequestDef,
  GroupsRequestDef,
} from "@app/types";

export const apiGroups = (params: GroupsRequestDef): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.groups, {
    params,
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};

export const apiArchivedGroups = (
  params: GroupsRequestDef,
): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.archivedGroups, {
    params,
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};

export const apiGroupDetail = (id: string): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.groupDetail(id), {
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};

export const apiGroupDetailCondition = (id: string): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.groupDetailCondition(id), {
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};

export const apiGroupIsAbnormality = (id: string): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.groupIsAbnormality(id), {
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};

export const apiGroupDetailInspectionForms = (
  id: string,
  params: GroupDetailInspectionFormsRequestDef,
): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.groupDetailInspectionForms(id), {
    params,
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};

export const apiGroupDetailInspectionFormDelete = (
  groupId: string,
  machineId: string,
  customInspectionFormId: string,
): Promise<AxiosResponse> => {
  return api.delete(
    ENDPOINTS.groupDetailInspectionDeleteOrUpdate(
      groupId,
      machineId,
      customInspectionFormId,
    ),
  );
};

export const apiGroupDetailInspectionFormUpdate = (
  groupId: string,
  machineId: string,
  customInspectionFormId: string,
  params: any,
): Promise<AxiosResponse> => {
  return api.put(
    ENDPOINTS.groupDetailInspectionDeleteOrUpdate(
      groupId,
      machineId,
      customInspectionFormId,
    ),
    params,
  );
};

export const apiGroupDetailInspectionFormStatus = (
  id: string,
): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.groupDetailInspectionFormStatus(id), {
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};

export const apiGroupMachinesDetail = (
  id: string,
  params: GroupMachinesRequestDef,
): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.groupMachinesDetail(id), {
    params,
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};

export const apiMachinesTransferGroups = (
  groupId: string,
): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.machinesTransferGroups(groupId));
};

export const apiUpdateMachineInGroup = (
  groupId: string,
  machineId: string,
  payload: any,
): Promise<AxiosResponse> => {
  return api.put(ENDPOINTS.updateMachineInGroup(groupId, machineId), payload);
};

export const apiDeleteMachineInGroupBulk = (
  groupId: string,
  payload: any,
): Promise<AxiosResponse> => {
  return api.post(ENDPOINTS.deleteMachineInGroupBulk(groupId), payload);
};

export const apiDeleteGroupsInBulk = (payload: {
  groupIds: string[];
}): Promise<AxiosResponse> => {
  return api.delete(ENDPOINTS.deleteGroupsInBulk(), {
    data: payload,
  });
};

export const apiArchiveGroupsInBulk = (payload: {
  groupIds: string[];
  isArchived: boolean;
}): Promise<AxiosResponse> => {
  return api.put(ENDPOINTS.archiveGroupsInBulk(), payload);
};

export const apiTransferMachinesInGroupBulk = (
  payload: any,
): Promise<AxiosResponse> => {
  return api.post(ENDPOINTS.transferMachinesInGroupBulk(), payload);
};

export const apiDeleteMachineInGroup = (
  groupId: string,
  machineId: string,
): Promise<AxiosResponse> => {
  return api.delete(ENDPOINTS.deleteMachineInGroup(groupId, machineId));
};

export const apiUpdateMachineInGroupStatus = (
  groupId: string,
  machineId: string,
  payload: any,
): Promise<AxiosResponse> => {
  return api.put(
    ENDPOINTS.updateMachineInGroupStatus(groupId, machineId),
    payload,
  );
};

export const apiUpdateInspectionItemStatus = (
  groupId: string,
  machineId: string,
  inspectionItemId: string,
): Promise<AxiosResponse> => {
  return api.put(
    ENDPOINTS.updateInspectionItemStatus(groupId, machineId, inspectionItemId),
  );
};

export const apiPostMachineInGroup = (
  groupId: string,
  payload: any,
): Promise<AxiosResponse> => {
  return api.post(ENDPOINTS.postMachineInGroup(groupId), payload);
};

export const apiPostMachineBulkInGroup = (
  groupId: string,
  payload: any,
): Promise<AxiosResponse> => {
  return api.post(ENDPOINTS.postMachineBulkInGroup(groupId), payload);
};

export const apiPostInspectionFormMultipleGroupsMachines = (
  payload: any,
): Promise<AxiosResponse> => {
  return api.post(
    ENDPOINTS.PostInspectionFormMultipleGroupsMachines(),
    payload,
  );
};

export const apiPostInspectionFormMultipleGroupsMachinesNew = (
  payload: any,
): Promise<AxiosResponse> => {
  return api.post(
    ENDPOINTS.PostInspectionFormMultipleGroupsMachinesNew(),
    payload,
  );
};

export const apiGroupMachineManufacturers = (
  groupId: string,
): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.groupMachineManufacturers(groupId), {
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};

export const apiGetusergroups = (userId: string): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.Getusergroups(userId));
};

export const apiGroupMachineTypes = (
  groupId: string,
): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.groupMachineTypes(groupId), {
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};

export const apiGroupMachineAvailable = (
  groupId: string,
): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.groupMachineAvailable(groupId));
};

export const apiGroupMachineAvailableWeb = (
  groupId: string,
): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.groupMachineAvailableWeb(groupId));
};

export const apiGroupMachineTypeWeb = (
  groupId: string,

  machineTypeId: string,
): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.groupMachineTypeWeb(groupId, machineTypeId));
};

export const apiGroupMachineTypeWebNew = (
  groupIds: string[],
): Promise<AxiosResponse> => {
  const groupIdsParam = groupIds.join(",");

  return api.get(ENDPOINTS.groupMachineTypeWebNew(groupIdsParam));
};

export const groupsMachinesReportsCSV = (
  machineIds: string[],
  startDate: string,
  endDate: string,
  timeZone: string,
): Promise<AxiosResponse> => {
  const machineIdsParam = machineIds.join(",");

  return api.get(
    ENDPOINTS.groupsMachinesReportsCSV(
      machineIdsParam,
      startDate,
      endDate,
      timeZone,
    ),
  );
};

export const groupsMachinesReportsCSVGroup = (
  groupId: string,
  startDate: string,
  endDate: string,
  timeZone: string,
): Promise<AxiosResponse> => {
  return api.get(
    ENDPOINTS.groupsMachinesReportsCSVGroup(
      groupId,
      startDate,
      endDate,
      timeZone,
    ),
  );
};

export const groupsMachinesReportsList = (
  groupId: string,
  layoutMode: string,
  month: string,
  date: string,
  timeZone: string,
  reportType: string,
  page: string,
  limit: string,
  order?: string,
  orderBy?: string,
  showAll?: boolean,
  search?: string,
  isAllDateRange?: boolean,
): Promise<AxiosResponse> => {
  const url = ENDPOINTS.groupsMachinesReportsSummaryList(
    groupId,
    layoutMode,
    month,
    date,
    timeZone,
    reportType,
    page,
    limit,
    order,
    orderBy,
    showAll,
    search,
    isAllDateRange,
  );

  return api.get(url, { skipGlobalLoader: true } as CustomAxiosRequestConfig);
};

export const getTranslationsList = (
  page: string,
  limit: string,
  order?: string,
  orderBy?: string,
  search?: string,
  platform?: string,
): Promise<AxiosResponse> => {
  const url = ENDPOINTS.translationsList(
    page,
    limit,
    order,
    orderBy,
    search,
    platform,
  );

  return api.get(url, { skipGlobalLoader: true } as CustomAxiosRequestConfig);
};

export const groupsMachinesReportsGrid = (
  groupId: string,
  layoutMode: string,
  month: string,
  date: string,
  timeZone: string,
  reportType: string,
  page: string,
  limit: string,
  order?: string,
  orderBy?: string,
  showAll?: boolean,
  search?: string,
): Promise<AxiosResponse> => {
  const url = ENDPOINTS.groupsMachinesReportsSummaryGrid(
    groupId,
    layoutMode,
    month,
    date,
    timeZone,
    reportType,
    page,
    limit,
    order,
    orderBy,
    showAll,
    search,
  );

  return api.get(url, { skipGlobalLoader: true } as CustomAxiosRequestConfig);
};

export const apiGetMachineDetailInfo = (
  groupId: string,
  machineId: string,
): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.machineDetailInfo(groupId, machineId), {
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};

export const apiGetMachineManufTypes = (
  groupId: string,
): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.apiGetMachineManufTypes(groupId), {
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};

type UpdateInspectionFormItemsRequest = {
  formName: string;
  machineId: string;
  items: {
    customInspectionItemId: string;
    name: string;
    description: string;
  }[];
};

type UpdateInspectionFormItemsResponse = {};

export const updateInspectionFormAndItemsApiCallWeb = (
  customInspectionFormId: string,
  body: UpdateInspectionFormItemsRequest,
): Promise<AxiosResponse<UpdateInspectionFormItemsResponse>> => {
  const url = ENDPOINTS.updateInspectionFormAndItemsWebNew(
    customInspectionFormId,
  );

  return api.put(url, body, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

type UpdateInspectionFormStatus = {};

export const updateInspectionFormStatusApiCall = (
  groupId: string,
  machineId: string,
  customInspectionFormId: string,
  status: "ARCHIVED" | "PUBLISHED",
): Promise<AxiosResponse<UpdateInspectionFormStatus>> => {
  const url = ENDPOINTS.updateInspectionFormStatus(
    groupId,
    machineId,
    customInspectionFormId,
  );

  return api.put(
    url,
    { status },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

export const updateInspectionFormStatusApiCallNew = (
  customInspectionFormId: string,
  status: "ARCHIVED" | "PUBLISHED",
): Promise<AxiosResponse<UpdateInspectionFormStatus>> => {
  const url = ENDPOINTS.updateInspectionFormStatusNew(customInspectionFormId);

  return api.put(
    url,
    { status },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

type DeleteInspectionResponse = {};

export const deleteInspectionApiCall = (
  groupId: string,
  machineId: string,
  inspectionId: string,
): Promise<AxiosResponse<DeleteInspectionResponse>> => {
  const url = ENDPOINTS.deleteInspection(groupId, machineId, inspectionId);

  return api.delete(url, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const apiGetMachineLocations = (
  groupId: string,
  params: GroupMachineLocationsRequest,
): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.getMachineLocations(groupId), {
    params,
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};

export const apiAddGroup = (payload: any): Promise<AxiosResponse> => {
  return api.post(ENDPOINTS.addGroup(), payload);
};

export const apiUpdateGroup = (
  groupId: string,
  payload: any,
): Promise<AxiosResponse> => {
  return api.put(ENDPOINTS.updateGroup(groupId), payload);
};

export const apiGetGroup = (id: string): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.apiGetGroup(id), {
    skipGlobalLoader: true,
  } as CustomAxiosRequestConfig);
};

export const apiPendingUsersWeb = (
  groupId: string,
  page: number,
  limit: number,
  order?: string,
  orderBy?: string,
  search?: string,
): Promise<AxiosResponse> => {
  return api.get(
    ENDPOINTS.pendingUsersWeb(groupId, page, limit, order, orderBy, search),
    { skipGlobalLoader: true } as CustomAxiosRequestConfig,
  );
};

export const apiAssignedUsersWeb = (
  groupId: string,
  page: number,
  limit: number,
  order?: string,
  orderBy?: string,
  search?: string,
): Promise<AxiosResponse> => {
  return api.get(
    ENDPOINTS.assignedUsersWeb(groupId, page, limit, order, orderBy, search),
    { skipGlobalLoader: true } as CustomAxiosRequestConfig,
  );
};

export const apiGetRoleTemplatePermissions = (): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.apiGetRoleTemplatePermissions());
};

export const apiGetUserAssignmentInfo = (
  groupId: string,
  userId: string,
): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.apiGetUserAssignmentInfo(groupId, userId));
};

export const apiDeleteUserAssignmentInfo = (
  groupId: string,
  userId: string,
): Promise<AxiosResponse> => {
  return api.delete(ENDPOINTS.apiDeleteUserAssignmentInfo(groupId, userId));
};

export const apiDenyUserAssignmentInfo = (
  groupId: string,
  userId: string,
): Promise<AxiosResponse> => {
  return api.put(ENDPOINTS.apiDenyUserAssignmentInfo(groupId, userId));
};

export const apiUpdateUserAssignmentInfo = (
  groupId: string,
  userId: string,
  payload: any,
): Promise<AxiosResponse> => {
  return api.put(
    ENDPOINTS.apiUpdateUserAssignmentInfo(groupId, userId),
    payload,
  );
};

export const apiAddUserAssignmentInfo = (
  groupId: string,
  payload: any,
): Promise<AxiosResponse> => {
  return api.post(ENDPOINTS.apiAddUserAssignmentInfo(groupId), payload);
};

export const apiCandidateUsersWeb = (
  groupId: string,
): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.apiCandidateUsersWeb(groupId));
};

export const apiCandidateUsersSearchWeb = (
  groupId: string,
  search: string,
): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.apiCandidateUsersSearchWeb(groupId, search));
};

export const apiGetTenantInfo = (email: string): Promise<AxiosResponse> => {
  return api.get(ENDPOINTS.tenantInfo(email));
};
